<template>
    <div class="lms__superadmin_customer_edit_contacts">
        <div class="lms__superadmin_customer_edit_contacts_header">
            <base-filter
                v-if="!isAddMode"
                :filter-data="rawItems"
                :search-active="true"
                :search-placeholder="$t('lms.customer.filter.searchPlaceholder')"
                :list-active="false"
                :actions-active="true"
                :actions-secondary-button-active="false"
                :actions-primary-button-text="$t('lms.customer.filter.buttonText')"
                :overlay="false"
                @emit-filter-result="setFilterResult"
                @emit-actions-primary="handleCreateContact"
            />
        </div>
        <div class="lms__superadmin_customer_edit_contacts_main">
            <template v-if="rawItems.length && outputItems">
                <lms-superadmin-customer-edit-contacts-table
                    :items="outputItems.length ? outputItems : rawItems"
                    @emit-edit="handleEditContact"
                    @emit-remove="openRemoveContactNotify"
                />
            </template>
            <template v-else-if="rawItems.length && !outputItems">
                <component-empty-state
                    :item="$t('lms.customer.emptyState.contact')"
                    :title="$t('lms.customer.emptyState.titleNotFound')"
                    :content="$t('lms.customer.emptyState.contentPlease')"
                    :submit-button-active="false"
                    :size="'full'"
                />
            </template>
            <template v-else-if="isAddMode">
                <component-empty-state
                    :item="$t('lms.customer.emptyState.contact')"
                    :title="$t(`lms.customer.emptyState.contacts`)"
                    :size="'full'"
                    :submit-button-active="false"
                />
            </template>
            <template v-else>
                <component-empty-state
                    :item="$t('lms.customer.emptyState.contact')"
                    :title="$t('lms.customer.emptyState.titleCreated')"
                    :content="$t('lms.customer.emptyState.contentClick')"
                    :size="'full'"
                    :submit-button-active="false"
                />
            </template>
        </div>
        <pop-notify
            ref="popnotifycreatecontact"
            :class="'pop__notify--createcontact'"
            :title-text="$t(`lms.customer.notify.titleText`)"
            :content-text="$t(`lms.customer.notify.contentText`)"
            :cancel-button-text="$t(`lms.customer.notify.cancelButton`)"
            :custom-button-danger="true"
            :custom-button-active="true"
            :custom-button-text="$t(`lms.customer.notify.customButton`)"
            :submit-button-text="$t(`lms.customer.notify.submitButton`)"
            :prevent-close="true"
            :size="'medium'"
            @emit-submit="customerSubmitRedirectToContact('add')"
            @emit-custom="redirectToContact('add')"
        />
        <pop-notify
            ref="popnotifyeditcontact"
            :class="'pop__notify--editcontact'"
            :title-text="$t(`lms.customer.notify.titleText`)"
            :content-text="$t(`lms.customer.notify.contentText`)"
            :cancel-button-text="$t(`lms.customer.notify.cancelButton`)"
            :custom-button-danger="true"
            :custom-button-active="true"
            :custom-button-text="$t(`lms.customer.notify.customButton`)"
            :submit-button-text="$t(`lms.customer.notify.submitButton`)"
            :prevent-close="true"
            :size="'medium'"
            @emit-submit="customerSubmitRedirectToContact('edit')"
            @emit-custom="redirectToContact('edit')"
        />
        <pop-notify
            ref="popnotifyremovecontact"
            :class="'pop__notify--removecontact'"
            :title-text="$t(`lms.customer.notify.titleTextRemove`)"
            :content-text="$t(`lms.customer.notify.contentTextRemove`)"
            :cancel-button-text="$t(`lms.customer.notify.cancelButton`)"
            :submit-button-text="$t(`lms.customer.notify.submitButton`)"
            :prevent-close="true"
            @emit-submit="customerRemoveContact"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import BaseFilter from '@/components/default/filters/BaseFilter'
import LmsSuperadminCustomerEditContactsTable from '@/components/lms/superadmin/customer/edit/LmsSuperadminCustomerEditContactsTable'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import { performSubmitValidatePromise, validateBeforeRouteLeave } from '@/helpers/mixins'

export default {
  name: 'lms-superadmin-customer-edit-contacts',
  components: { PopNotify, ComponentEmptyState, LmsSuperadminCustomerEditContactsTable, BaseFilter },
  mixins: [validateBeforeRouteLeave, performSubmitValidatePromise],
  data () {
    return {
      outputItems: []
    }
  },
  computed: {
    rawItems () {
      return this.$store.getters.getLmsSuperadminCustomerContacts
    },
    customerId () {
      return this.$store.getters.getLmsSuperadminCustomerId
    },
    //
    rootItemName () {
      return 'customer'
    },
    rootParent () {
      return this.$parent.$parent.$parent
    },
    nameActionCreate () {
      return 'lmsSuperadminCustomerCreate'
    },
    nameActionUpdate () {
      return 'lmsSuperadminCustomerUpdate'
    },
    //
    isAddMode () {
      return this.$route.name.includes('-add')
    }
  },
  methods: {
    handleCreateContact () {
      if (this.rootParent.continueRedirect) {
        this.redirectToContact('add')
      } else {
        this.openCreateContactNotify()
      }
    },
    handleEditContact (data) {
      if (this.rootParent.continueRedirect) {
        this.redirectToContact('edit', data)
      } else {
        this.openEditContactNotify(data)
      }
    },
    openCreateContactNotify () {
      this.$refs.popnotifycreatecontact.openNotify()
    },
    openEditContactNotify (data) {
      this.$refs.popnotifyeditcontact.openNotify()
      this.$refs.popnotifyeditcontact.setStoreValue(data)
    },
    openRemoveContactNotify (data) {
      this.$refs.popnotifyremovecontact.openNotify()
      this.$refs.popnotifyremovecontact.setStoreValue(data)
    },
    customerSubmitRedirectToContact (type = 'add') {
      const customerId = this.customerId
      let contactId
      if (type === 'edit') {
        contactId = this.$refs.popnotifyeditcontact.storeValue
      }
      this.performSubmitValidatePromise(false).then((response) => {
        this.$router.push({
          name: `lms-superadmin-customer-contact-${type}`,
          params: {
            customerId: customerId,
            contactId: contactId
          }
        })
      })
    },
    customerRemoveContact () {
      const notify = this.$refs.popnotifyremovecontact
      const contactId = notify.storeValue
      this.$store.dispatch('lmsSuperadminCustomerContactRemove', contactId).then((response) => {
        this.$store.dispatch('lmsSuperadminCustomerRemoveContactById', contactId)
        notify.closeNotify()
      })
    },
    redirectToContact (type = 'add', data) {
      const customerId = String(this.customerId)
      let contactId
      if (type === 'edit') {
        contactId = data || this.$refs.popnotifyeditcontact.storeValue
      }
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({
        name: `lms-superadmin-customer-contact-${type}`,
        params: {
          customerId: customerId,
          contactId: contactId
        }
      })
    },
    //
    setFilterResult (data) {
      this.outputItems = data
    }
  }
}
</script>
